import jwt from "jwt-simple";

export default [
	{
		path: "*",
		meta: {
			public: true
		},
		redirect: {
			path: "/404"
		}
	},
	{
		path: "/home",
		meta: {
			public: true
		},
		name: "Home",
		component: () => import( /* webpackChunkName: "routes" */ `@/views/Home.vue`)
	},
	{
		path: "/login",
		meta: {
			public: true
		},
		name: "Login",
		component: () => import( /* webpackChunkName: "routes" */ `@/views/Login.vue`)
	},
	{
		path: "/",
		meta: {
			title: "UP mo"
		},
		name: "Root",
		redirect: {
			name: "Login"
			//name: "Login"
		}
	},
	{
	path: "/principal",
	meta: {
		breadcrumb: true,
		login: true,
		title: "UP mo"
	},
	name: "principal",
	component: () =>
		import(
		/* webpackChunkName: "routes" */
		`@/views/Principal.vue`
		)
	},
	{
	path: "/poll",
	meta: {
		breadcrumb: true,
		login: true,
		title: "UP mo"
	},
	name: "poll",
	component: () =>
		import(
		/* webpackChunkName: "routes" */
		`@/views/Poll.vue`
		)
	},
	{
		path: "/exam",
		meta: {
			breadcrumb: true,
			login: true,
			title: "UP mo"
		},
		name: "exam",
		component: () =>
			import(
			/* webpackChunkName: "routes" */
			`@/views/Exam.vue`
			)
	},
	{
		path: "/exam2",
		meta: {
			breadcrumb: true,
			login: true,
			title: "UP mo"
		},
		name: "exam2",
		component: () =>
			import(
			/* webpackChunkName: "routes" */
			`@/views/Exam2.vue`
			)
	},
	{
		path: "/evaluation/:step?/:status?",
		meta: {
			breadcrumb: true,
			login: true,
			title: "UP mo"
		},
		name: "evaluation",
		component: () => import( /* webpackChunkName: "routes" */ `@/views/EvaluationProcess.vue`)
	},
	{
		path: "/register",
		meta: {
			public: true
		},
		name: "Register",
		component: () => import( /* webpackChunkName: "routes" */ `@/views/Register.vue`)
	},
	{
		path: "/languages",
		meta: {
			public: true
		},
		name: "Languages",
		component: () => import( /* webpackChunkName: "routes" */ `@/views/Languages.vue`)
	},
	{
		path: "/MinorConsentForm",
		meta: {
			public: true
		},
		name: "MinorConsentForm",
		component: () => import( /* webpackChunkName: "routes" */ `@/components/MinorConsentForm.vue`)
	},

	{
	path: "/enrollment/:course_id?",
	meta: {
		breadcrumb: true,
		login: true,
		title: "UP mo"
	},
	name: "enrollment",

	beforeEnter: (to, from, next) => {

		if (localStorage.lastCourse) {
			let course = localStorage.getItem("lastCourse");
			let lastCourse = jwt.decode(course, process.env.VUE_APP_JWT_TOKEN_KEY);

			if (lastCourse.course_id == to.params.course_id) {
			next();
			} else {
			next({name: 'principal'});
			}
			
		}else {
		next({name: 'principal'});
		}
		
		
		if(to.params.course_id){
		next();
		}else{
		next({name: 'principal'});
		}
	},

	component: () =>
		import(
		/* webpackChunkName: "routes" */
		`@/views/EnrollmentProcess.vue`
		)
	},
];